const API_URL = "https://www.buydubai.cz.test/api";
import { BASE_URL_API } from '../misc/consts';

export default () => ({
  property_types: [],
  disposition: [],
  locations: [],
  points_of_view: [],
  extra_rooms: [],
  cities: [],

  init() {
    this.fetchTaxonomy("property_types");
    this.fetchTaxonomy("disposition");
    this.fetchTaxonomy("locations");
    this.fetchTaxonomy("points_of_view");
    this.fetchTaxonomy("extra_rooms");

    fetch(`${BASE_URL_API}/collections/cities/entries?filter[site]=en&limit=9000&fields=title,id,slug&sort=title`)
      .then((response) => response.json())
      .then((response) => {
        this.cities = response.data;
      });

  },

  fetchTaxonomy(name) {
    fetch(
      `${BASE_URL_API}/taxonomies/${name}/terms?filter[site]=en&limit=9000&fields=title,slug&sort=title`
    )
      .then((response) => response.json())
      .then((response) => {
        this[name] = response.data;
      });
  },

  createValue(item) {
    return JSON.stringify({ text: item.title, value: item.slug });
  },
});
